export default "__VITE_ASSET__DE7lBOgF__"